import {GEN_TOKEN, GET_TOKEN, GET_USER_INFO, SIGN_IN, SIGN_OUT} from "./actions.type";
import {authService} from "../service/authService";
import axios from 'axios';

function initState() {
    return {
        isLogged: false,
        token: null,
        user: {}
    }
}

const state = initState();

const actions = {
    async [GET_USER_INFO]({commit}) {
        let result = await authService.getUserInfo();
        commit(GET_USER_INFO, result);
        return result;
    },

    async [SIGN_IN]({commit}, data) {
        let result = await authService.signIn(data.username, data.password);
        commit(SIGN_IN, result);
        commit(GET_TOKEN, result.token);
        return result;
    },

    async [GET_TOKEN]({commit}) {
        let token = localStorage.getItem('token');
        if (token) {
            commit(GET_TOKEN, token);
        }
        return token;
    },

    async [GEN_TOKEN]({commit}, policeStationId) {
        let result = await authService.getToken(policeStationId);
        commit(GET_TOKEN, result.token);
        return result;
    },


    async [SIGN_OUT]({commit}) {
        let result = await authService.signOut();
        commit(SIGN_OUT);
        return result;
    },
};

const mutations = {
    [GET_USER_INFO](state, user) {
        state.user = user;
    },

    [SIGN_IN](state, user) {
        state.user = user;
        state.isLogged = true;
    },

    [GET_TOKEN](state, token) {
        state.token = token;

        // set header
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        // set storage
        localStorage.setItem('token', token);

        state.isLogged = true;
    },
    [SIGN_OUT](state) {
        state.user = {};
        localStorage.removeItem('token');
        state.isLogged = false;
    },
};

const getters = {};

export default {
    state,
    actions,
    mutations,
    getters
};
